export default (() => {

    const global = {
        elements: {},
        pageData: {},
    };

    function initialise (pin, pinShareMessage) {
        _cacheDom();
        _cachePageData(pin, pinShareMessage);
        _bindevents();
        _initComponents();
    }

    function _cacheDom () {
        global.elements.copyButton = document.querySelector('[data-copy-button]');
    }

    function _cachePageData(pin, pinShareMessage){
        if(global.elements.copyButton){
            global.pageData.showShareSheet = navigator.share && wealthify.user.isOnMobileDevice();
            global.pageData.pin = pin;
            global.pageData.pinShareMessage = pinShareMessage.replace(/&#39;/g, '\'');
        }
    }

    // Initialize confirm components
    function _initComponents(){
        if(global.elements.copyButton && global.pageData.showShareSheet){
            _setButtonToShare();
        }
    }

    function _bindevents(){
        if(global.elements.copyButton){
            if(global.pageData.showShareSheet){

                global.elements.copyButton.addEventListener('click', () => { 
                    navigator.share({
                        title: 'Wealthify Invite PIN code.',
                        text: `${global.pageData.pinShareMessage}\n\n${global.pageData.pin}`,
                    });
                });
    
            } else {
    
                global.elements.copyButton.addEventListener('click', () => {  
                    _showCopiedButton();
                    _copyCodeToClipboard();  
                    setTimeout(_resetButton, 3000);
                });
    
            }
        }
    }

    function _setButtonToShare(){
        global.elements.copyButton.iconleft = 'share';
        global.elements.copyButton.label = 'Share PIN Code';
    }

    function _copyCodeToClipboard(){
        navigator.clipboard.writeText(`${global.pageData.pinShareMessage}\n\n${global.pageData.pin}`);
    }

    function _showCopiedButton(){
        global.elements.copyButton.iconleft = 'success-outlined';
        global.elements.copyButton.label = 'Copied';
    }

    function _resetButton(){
        global.elements.copyButton.iconleft = 'documents';
        global.elements.copyButton.label = 'Copy PIN code to clipboard';
    }

    return {initialise};
})();